const horizontalRule = ["M0 7.5l16 0l0 1l-16 0z"];
export {
  horizontalRule
};
//# sourceMappingURL=horizontalRule.js.map
